import { render } from "./ConsultDetail.vue?vue&type=template&id=3c5aa579&scoped=true"
import script from "./ConsultDetail.vue?vue&type=script&lang=js"
export * from "./ConsultDetail.vue?vue&type=script&lang=js"

import "./ConsultDetail.vue?vue&type=style&index=0&id=3c5aa579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5aa579"]])

export default __exports__